export const playerSkeletalVisuals = {
  version: 2,
  root: "root",
  renderScale: 0.58,
  bones: {
    root: { parent: null, x: 0, y: 0, rotation: 0 },
    pelvis: { parent: "root", x: 0, y: -174, rotation: 0 },
    torso: { parent: "pelvis", x: 0, y: -45, rotation: 0 },
    chest: { parent: "torso", x: 0, y: -55, rotation: 0 },
    neck: { parent: "chest", x: 0, y: -35, rotation: 0 },
    head: { parent: "neck", x: 0, y: -15, rotation: 0 },
    upper_arm_l: { parent: "chest", x: -47, y: -5, rotation: 0.1 },
    forearm_l: { parent: "upper_arm_l", x: 5, y: 55, rotation: -0.1 },
    hand_l: { parent: "forearm_l", x: 18, y: 57, rotation: 0.04 },
    upper_arm_r: { parent: "chest", x: 50, y: -2, rotation: -0.03 },
    forearm_r: { parent: "upper_arm_r", x: 9, y: 58, rotation: 0.12 },
    hand_r: { parent: "forearm_r", x: 15, y: 50, rotation: -0.02 },
    weapon_r: { parent: "hand_r", x: 8, y: 0, rotation: -0.9 },
    offhand_l: { parent: "hand_l", x: -7, y: 0, rotation: 0.12 },
    thigh_l: { parent: "pelvis", x: -23, y: 14, rotation: 0.03 },
    shin_l: { parent: "thigh_l", x: -9, y: 78, rotation: 0.04 },
    foot_l: { parent: "shin_l", x: -3, y: 77, rotation: -0.05 },
    thigh_r: { parent: "pelvis", x: 33, y: 10, rotation: -0.03 },
    shin_r: { parent: "thigh_r", x: 14, y: 78, rotation: -0.02 },
    foot_r: { parent: "shin_r", x: 11, y: 77, rotation: 0.04 },
    cloak_back: { parent: "chest", x: -3, y: -6, rotation: 0 },
  },
  slots: [
    { name: "foot_l", bone: "foot_l", assetKey: "skeletal_base_foot_l", anchor: { x: 0.52, y: 0.22 }, order: 10, scale: 1 },
    { name: "shin_l", bone: "shin_l", assetKey: "skeletal_base_shin_l", anchor: { x: 0.54, y: 0.21 }, order: 20, scale: 1 },
    { name: "thigh_l", bone: "thigh_l", assetKey: "skeletal_base_thigh_l", anchor: { x: 0.52, y: 0.31 }, order: 30, scale: 1 },
    { name: "upper_arm_l", bone: "upper_arm_l", assetKey: "skeletal_base_upper_arm_l", anchor: { x: 0.46, y: 0.22 }, order: 35, scale: 1 },
    { name: "forearm_l", bone: "forearm_l", assetKey: "skeletal_base_forearm_l", anchor: { x: 0.4, y: 0.33 }, order: 36, scale: 1 },
    { name: "foot_r", bone: "foot_r", assetKey: "skeletal_base_foot_r", anchor: { x: 0.38, y: 0.29 }, order: 40, scale: 1 },
    { name: "shin_r", bone: "shin_r", assetKey: "skeletal_base_shin_r", anchor: { x: 0.58, y: 0.18 }, order: 50, scale: 1 },
    { name: "thigh_r", bone: "thigh_r", assetKey: "skeletal_base_thigh_r", anchor: { x: 0.54, y: 0.31 }, order: 60, scale: 1 },
    { name: "pelvis", bone: "pelvis", assetKey: "skeletal_base_pelvis", anchor: { x: 0.43, y: 0.54 }, order: 70, scale: 1 },
    { name: "torso", bone: "torso", assetKey: "skeletal_base_torso", anchor: { x: 0.45, y: 0.43 }, order: 80, scale: 1 },
    { name: "chest", bone: "chest", assetKey: "skeletal_base_chest", anchor: { x: 0.52, y: 0.43 }, order: 90, scale: 1 },
    { name: "upper_arm_r", bone: "upper_arm_r", assetKey: "skeletal_base_upper_arm_r", anchor: { x: 0.52, y: 0.24 }, order: 170, scale: 1 },
    { name: "forearm_r", bone: "forearm_r", assetKey: "skeletal_base_forearm_r", anchor: { x: 0.56, y: 0.38 }, order: 180, scale: 1 },
    { name: "head", bone: "head", assetKey: "skeletal_base_head", anchor: { x: 0.46, y: 0.8 }, order: 210, scale: 1 },
  ],
  slotAttachments: {
    weapon: { bone: "weapon_r", anchor: { x: 0.18, y: 0.56 }, order: 165 },
    offhand: { bone: "offhand_l", anchor: { x: 0.5, y: 0.5 }, order: 125 },
    head: { bone: "head", anchor: { x: 0.5, y: 0.72 }, order: 220 },
    body: { bone: "torso", anchor: { x: 0.5, y: 0.18 }, order: 95 },
    legs: { bone: "pelvis", anchor: { x: 0.5, y: 0.1 }, order: 75 },
    feet: { bone: "foot_r", anchor: { x: 0.35, y: 0.5 }, order: 65 },
    belt: { bone: "pelvis", anchor: { x: 0.5, y: 0.42 }, order: 96 },
    shoulders: { bone: "chest", anchor: { x: 0.5, y: 0.2 }, order: 160 },
    hands: { bone: "hand_r", anchor: { x: 0.5, y: 0.5 }, order: 195 },
    neck: { bone: "neck", anchor: { x: 0.5, y: 0.35 }, order: 205 },
    ring: { bone: "hand_l", anchor: { x: 0.5, y: 0.5 }, order: 140 },
    trinket: { bone: "chest", anchor: { x: 0.5, y: 0.45 }, order: 206 },
  },
  animations: {
    idle: {
      duration: 1.6,
      loop: true,
      bones: {
        root: [{ t: 0, y: 0 }, { t: 0.5, y: -1.5 }, { t: 1, y: 0 }],
        chest: [{ t: 0, rotation: -0.01 }, { t: 0.5, rotation: 0.02 }, { t: 1, rotation: -0.01 }],
        head: [{ t: 0, rotation: 0.015 }, { t: 1, rotation: 0.015 }],
        forearm_r: [{ t: 0, rotation: -0.03 }, { t: 1, rotation: -0.03 }],
        hand_r: [{ t: 0, rotation: -0.05 }, { t: 1, rotation: -0.05 }],
        weapon_r: [{ t: 0, rotation: -1.05 }, { t: 1, rotation: -1.05 }],
      },
    },
    walk: {
      duration: 0.9,
      loop: true,
      bones: {
        pelvis: [{ t: 0, y: -1 }, { t: 0.5, y: 1.5 }, { t: 1, y: -1 }],
        upper_arm_r: [{ t: 0, rotation: 0.14 }, { t: 0.5, rotation: -0.2 }, { t: 1, rotation: 0.14 }],
        upper_arm_l: [{ t: 0, rotation: -0.12 }, { t: 0.5, rotation: 0.18 }, { t: 1, rotation: -0.12 }],
        thigh_r: [{ t: 0, rotation: -0.16 }, { t: 0.5, rotation: 0.14 }, { t: 1, rotation: -0.16 }],
        thigh_l: [{ t: 0, rotation: 0.14 }, { t: 0.5, rotation: -0.16 }, { t: 1, rotation: 0.14 }],
        shin_r: [{ t: 0, rotation: 0.05 }, { t: 0.5, rotation: -0.08 }, { t: 1, rotation: 0.05 }],
        shin_l: [{ t: 0, rotation: -0.08 }, { t: 0.5, rotation: 0.05 }, { t: 1, rotation: -0.08 }],
        weapon_r: [{ t: 0, rotation: -0.9 }, { t: 1, rotation: -0.9 }],
      },
    },
    melee: {
      duration: 0.65,
      loop: false,
      bones: {
        torso: [{ t: 0, rotation: -0.05 }, { t: 0.38, rotation: 0.08, x: 4 }, { t: 0.68, rotation: -0.03, x: 1 }, { t: 1, rotation: 0 }],
        upper_arm_r: [{ t: 0, rotation: -0.55 }, { t: 0.38, rotation: -1.05 }, { t: 0.62, rotation: 0.18 }, { t: 1, rotation: -0.12 }],
        forearm_r: [{ t: 0, rotation: -0.36 }, { t: 0.38, rotation: -0.7 }, { t: 0.62, rotation: 0.36 }, { t: 1, rotation: 0.08 }],
        hand_r: [{ t: 0, rotation: -0.22 }, { t: 0.62, rotation: 0.3 }, { t: 1, rotation: -0.08 }],
        weapon_r: [{ t: 0, rotation: -1.35 }, { t: 0.38, rotation: -1.65 }, { t: 0.62, rotation: -0.18 }, { t: 1, rotation: -0.95 }],
      },
    },
    bow: {
      duration: 0.75,
      loop: false,
      bones: {
        upper_arm_l: [{ t: 0, rotation: -0.25 }, { t: 0.42, rotation: -0.78 }, { t: 1, rotation: -0.45 }],
        forearm_l: [{ t: 0, rotation: 0.12 }, { t: 0.42, rotation: 0.45 }, { t: 1, rotation: 0.1 }],
        upper_arm_r: [{ t: 0, rotation: -0.1 }, { t: 0.42, rotation: -0.62 }, { t: 1, rotation: -0.1 }],
        forearm_r: [{ t: 0, rotation: 0.24 }, { t: 0.42, rotation: -0.28, x: -6 }, { t: 0.72, rotation: 0.36, x: 1 }, { t: 1, rotation: 0.16 }],
        weapon_r: [{ t: 0, rotation: -1.45 }, { t: 1, rotation: -1.45 }],
      },
    },
    throw: {
      duration: 0.7,
      loop: false,
      bones: {
        torso: [{ t: 0, rotation: -0.04 }, { t: 0.42, rotation: -0.12 }, { t: 0.68, rotation: 0.1 }, { t: 1, rotation: 0 }],
        upper_arm_r: [{ t: 0, rotation: -0.95 }, { t: 0.42, rotation: -1.2 }, { t: 0.68, rotation: 0.55 }, { t: 1, rotation: -0.1 }],
        forearm_r: [{ t: 0, rotation: -0.4 }, { t: 0.42, rotation: -0.65 }, { t: 0.68, rotation: 0.45 }, { t: 1, rotation: 0 }],
        hand_r: [{ t: 0, rotation: -0.2 }, { t: 0.68, rotation: 0.36 }, { t: 1, rotation: 0 }],
      },
    },
    cast: {
      duration: 0.9,
      loop: false,
      bones: {
        chest: [{ t: 0, y: 0 }, { t: 0.5, y: -4 }, { t: 1, y: 0 }],
        upper_arm_l: [{ t: 0, rotation: -0.1 }, { t: 0.5, rotation: -0.8 }, { t: 1, rotation: -0.2 }],
        forearm_l: [{ t: 0, rotation: 0 }, { t: 0.5, rotation: -0.4 }, { t: 1, rotation: 0 }],
        upper_arm_r: [{ t: 0, rotation: -0.1 }, { t: 0.5, rotation: -0.72 }, { t: 1, rotation: -0.15 }],
        forearm_r: [{ t: 0, rotation: 0.1 }, { t: 0.5, rotation: -0.34 }, { t: 1, rotation: 0.08 }],
        weapon_r: [{ t: 0, rotation: -0.95 }, { t: 0.5, rotation: -1.35 }, { t: 1, rotation: -0.95 }],
      },
    },
    guard: {
      duration: 0.8,
      loop: false,
      bones: {
        torso: [{ t: 0, rotation: -0.04 }, { t: 1, rotation: -0.04 }],
        upper_arm_l: [{ t: 0, rotation: -0.86 }, { t: 1, rotation: -0.86 }],
        forearm_l: [{ t: 0, rotation: 0.74 }, { t: 1, rotation: 0.74 }],
        offhand_l: [{ t: 0, rotation: -0.1 }, { t: 1, rotation: -0.1 }],
        upper_arm_r: [{ t: 0, rotation: -0.34 }, { t: 1, rotation: -0.34 }],
        forearm_r: [{ t: 0, rotation: -0.12 }, { t: 1, rotation: -0.12 }],
        weapon_r: [{ t: 0, rotation: -1.18 }, { t: 1, rotation: -1.18 }],
      },
    },
    hurt: {
      duration: 0.5,
      loop: false,
      bones: {
        root: [{ t: 0, x: 0 }, { t: 0.4, x: -7 }, { t: 1, x: 0 }],
        torso: [{ t: 0, rotation: 0 }, { t: 0.4, rotation: -0.14 }, { t: 1, rotation: 0 }],
        head: [{ t: 0, rotation: 0 }, { t: 0.4, rotation: -0.18 }, { t: 1, rotation: 0 }],
        weapon_r: [{ t: 0, rotation: -0.9 }, { t: 1, rotation: -0.9 }],
      },
    },
  },
};
